import { createRequestActions } from "common/helpers/action";

export const initKkmGroupAdd = createRequestActions("KKM_GROUP.ADD.INIT");
export const sendKkmGroupAdd = createRequestActions("KKM_GROUP.ADD.SEND");
